import { combineReducers } from "redux";
import getAlertsReducer from "./reducers/getAlerts";
export default combineReducers({ getAlertsReducer });
